export default "__VITE_ASSET__ve7rGFdT__"